import { gql } from '@apollo/client';

export const CREATE_SUBDIVISION_MUTATOR = gql`
  mutation createSubdivisionMutator(
    $group_id: String
    $company_id: String
    $subdivision_name: String
    $division: JSON
    $user_email: String
  ) {
    createSubdivision(
      group_id: $group_id
      company_id: $company_id
      subdivision_name: $subdivision_name
      division: $division
      user_email: $user_email
    )
  }
`;

export const UPDATE_SUBDIVISION_MUTATOR = gql`
  mutation updateSubdivisionMutator(
    $group_id: String
    $company_id: String
    $updated_subdivision: JSON
    $original_data: JSON
    $user_email: String
  ) {
    updateSubdivision(
      group_id: $group_id
      company_id: $company_id
      updated_subdivision: $updated_subdivision
      original_data: $original_data
      user_email: $user_email
    )
  }
`;

export const DELETE_SUBDIVISION_MUTATOR = gql`
  mutation updateSubdivisionMutator(
    $group_id: String
    $company_id: String
    $subdivision_id: String
    $subdivision_name: String
    $delete_sites: [JSON]
    $user_email: String
  ) {
    deleteSubdivision(
      group_id: $group_id
      company_id: $company_id
      subdivision_id: $subdivision_id
      subdivision_name: $subdivision_name
      delete_sites: $delete_sites
      user_email: $user_email
    )
  }
`;

export const ARCHIVE_SUBDIVISION_MUTATOR = gql`
  mutation archiveSubdivisionMutator(
    $group_id: String
    $company_id: String
    $subdivision_id: String
    $archive_sites: [JSON]
    $user_email: String
  ) {
    archiveSubdivision(
      group_id: $group_id
      company_id: $company_id
      subdivision_id: $subdivision_id
      archive_sites: $archive_sites
      user_email: $user_email
    )
  }
`;

export const UNARCHIVE_SUBDIVISION_MUTATOR = gql`
  mutation unarchiveSubdivisionMutator(
    $group_id: String
    $company_id: String
    $subdivision_id: String
    $unarchive_sites: [JSON]
    $user_email: String
  ) {
    unarchiveSubdivision(
      group_id: $group_id
      company_id: $company_id
      subdivision_id: $subdivision_id
      unarchive_sites: $unarchive_sites
      user_email: $user_email
    )
  }
`;
